/**
 * F-4 (review front spec-015 it.1) — 3 computeds de badge extraídos de
 * `chat-message.vue` (1077 linhas, acima do teto de 500 do repo, já estava
 * em 916 antes desta branch) para este irmão, no MESMO molde de
 * `../../api/agentes-do-turno.js`: funções PURAS, sem `store.dispatch`, sem
 * `this` — o componente injeta os valores já lidos (`this.$store`,
 * `this.storeModule`, `this.isStreaming`, ...) e delega.
 */
import { ESTADO_CARREGANDO, ESTADO_ERRO, ESTADO_SUCESSO, ESTADO_VAZIO } from '@modules/aawz-intelligence-v2/components/agent-badge/agent-badge.vue'

/**
 * RF-G2 — TODOS os agentes desta mensagem persistida, na ordem de chegada.
 * `agentesDaMensagem` é o getter ADITIVO ([RF-G2]); quando ausente do store
 * mockado (fake store de teste que só registra o singular `agenteDaMensagem`,
 * ou build que ainda não carregou o getter novo) cai para `agenteDoTurno`,
 * virando lista de 1 — é o MESMO dado, só sem o getter novo no meio. `[]`
 * quando a mensagem não tem agente nenhum (turno antigo).
 */
export function agentesDaMensagemAtual({ store, storeModule, messageId, agenteDoTurno }) {
  if (!messageId) return []
  if (store) {
    const buscar = store.getters[storeModule + '/agentesDaMensagem']
    if (buscar) {
      const lista = buscar(messageId)
      if (lista && lista.length) return lista
    }
  }
  return agenteDoTurno ? [agenteDoTurno] : []
}

/**
 * RF-G2 — espelho AO VIVO do turno em streaming (`agentesDoTurnoAoVivo` no
 * store, atualizado por `apiChat._onAgentSelected`/`_onEventStart` a cada
 * agente que chega). `[]` quando o getter não existe (fake store de teste)
 * ou o roteamento ainda não produziu nenhum agente — nesse caso
 * `badgesDoTurno` cai no badge único `carregando` de sempre.
 */
export function agentesEmStreamingAtual({ store, storeModule }) {
  if (!store) return []
  const lista = store.getters[storeModule + '/agentesDoTurnoAoVivo']
  return lista && lista.length ? lista : []
}

/**
 * RF-G2 (verdict de review front, spec-010) — lista de badges A RENDERIZAR
 * neste turno, um por agente do fan-out. Os 3 estados que NÃO dependem de
 * QUAL agente (carregando/erro/vazio) continuam colapsando num badge ÚNICO
 * — só o SUCESSO vira N badges: um por entrada de `agentesEmStreaming`
 * (streaming) ou `agentesDaMensagem` (persistida). Streaming com 0 agentes
 * ainda resolvidos cai no `carregando` de sempre — não é "sucesso com lista
 * vazia".
 *
 * `rotuloDeFallback` só entra no badge de ERRO: o turno morreu antes do
 * `agent-selected`, não há slug, e é o chamador (`chat-message.vue::
 * rotuloDoAgenteSemResolucao`) quem resolve a cascata agente ativo →
 * principal da persona → genérico. Os outros três estados NÃO o recebem —
 * no sucesso ele venceria o rótulo derivado do slug (`agent-badge.vue::
 * rotuloAgente`) e trocaria quem de fato respondeu.
 */
export function badgesDoTurno({
  isStreaming,
  hubEmStreaming,
  hubDoTurno,
  erroDoTurno,
  agentesEmStreaming,
  agentesDaMensagem,
  rotuloDeFallback = '',
}) {
  if (isStreaming) {
    // `.filter(agentSlug)` — uma entrada com hub conhecido mas SEM slug (o
    // backend grava o hub da conversa mesmo sem o agente específico
    // capturado) não é "sucesso com 1 badge": é o mesmo caso `vazio` de
    // sempre, só o rótulo do hub sem tooltip. Sem o filtro, uma entrada
    // assim viraria SUCESSO com rótulo vazio — regressão do contrato.
    const aoVivo = agentesEmStreaming.filter((agente) => agente.agentSlug)
    if (!aoVivo.length) {
      return [{ hub: hubEmStreaming, agentSlug: '', motivo: '', estado: ESTADO_CARREGANDO }]
    }
    return aoVivo.map((agente) => ({
      hub: agente.hub || hubEmStreaming,
      agentSlug: agente.agentSlug,
      motivo: agente.motivo,
      estado: ESTADO_SUCESSO,
    }))
  }
  if (erroDoTurno) {
    return [{
      hub: hubDoTurno,
      agentSlug: '',
      agentLabel: rotuloDeFallback,
      motivo: '',
      estado: ESTADO_ERRO,
    }]
  }
  const persistidos = agentesDaMensagem.filter((agente) => agente.agentSlug)
  if (!persistidos.length) {
    return [{ hub: hubDoTurno, agentSlug: '', motivo: '', estado: ESTADO_VAZIO }]
  }
  return persistidos.map((agente) => ({
    hub: agente.hub || hubDoTurno,
    agentSlug: agente.agentSlug,
    motivo: agente.motivo,
    estado: ESTADO_SUCESSO,
  }))
}
